import React from 'react';

import { FormControl, TextField } from '@mui/material';
import { DEFAULT_FIELD_STYLE, editDrawerTextFieldStyles } from 'common/utils/StyleHelpers';

export interface ILicenseCustomTextFieldProps {
    label?: string,
    value?: string,
    placeholder?: string,
    onChange?: (value: string) => void,
    hasError?: boolean,
    defaultValue?: string,
    disabled?: boolean,
    inputRef?: React.Ref<HTMLInputElement | undefined>
}

export function LicenseCustomTextField(props: Readonly<ILicenseCustomTextFieldProps>) {
    const {
        label,
        value,
        placeholder,
        onChange,
        hasError,
        defaultValue,
        disabled
    } = props;

    const handleFieldChange: React.ChangeEventHandler<HTMLInputElement> = event => {
        onChange?.(event.target.value);
    };

    const editableTextField = (
        <FormControl>
            <TextField
                sx={editDrawerTextFieldStyles(hasError)}
                size="small"
                label={label}
                placeholder={placeholder}
                variant="filled"
                value={value}
                onChange={handleFieldChange}
                inputRef={props.inputRef}
            />
        </FormControl>
    );

    const disabledTextField = (
        <TextField
            sx={DEFAULT_FIELD_STYLE}
            size="small"
            variant="filled"
            defaultValue={defaultValue}
            disabled={disabled}
            label={label}
        />
    );

    if(disabled || defaultValue) {
        return disabledTextField;
    }

    return editableTextField;
}
